import { OrderEnum } from "@/utils/enum";
import CryptoJs from "crypto-js";
import Config from "@/config/config";

const Func = {
    imgUrlFormat: (url = "") => {
        let validateUrl = (url.indexOf("http") === -1)
        if (validateUrl) {
            return Config.imgPrefix + url;
        } else {
            return url;
        }
    },
    getCancelRuleList: (res = [], key = "key") => {
        try {
            if (res) {
                res.sort(function (x, y) {
                    return -(x[0] - y[0]);//升序
                })
            }
            return res ? res : [];
        } catch ($e) {

        } finally {

        }

        return [];

    },
    isOrderActionShow: (item, actionName) => {

        if (actionName === 'pay') {
            if (item.sub_status === OrderEnum.orderToPaid) {
                return true;
            }
            return false;

        }
        if (actionName === 'apply-refund') {
            if (item.sub_status === OrderEnum.orderIsConfirmed) {
                return true;
            }
            return false;

        }

        if (actionName === 'cancel') {
            if (item.sub_status === OrderEnum.orderToPaid) {
                return true;
            }

            if (item.sub_status === OrderEnum.orderToRefund) {
                return false;
            }

            if (item.sub_status === OrderEnum.orderCanceled) {
                return false;
            }
            if (item.sub_status === OrderEnum.orderToConfirm) {
                return true;
            }
            if (item.sub_status === OrderEnum.orderIsConfirmed) {
                return false;
            }
            if (item.sub_status === OrderEnum.orderFinish) {
                return false;
            }
            if (item.sub_status === OrderEnum.orderClose) {
                return false;
            }
            if (item.sub_status === OrderEnum.orderMealDone) {
                return false;
            }
            if (item.sub_status === OrderEnum.orderRefundDepositReceipt) {
                return false;
            }
        }

        if (actionName === "apply-refund-deposit") {
            if (item.sub_status === OrderEnum.orderMealDone) {
                return true;
            }
            return false;
        }

        return true;
    }
}

export { Func }

/**
 * 默认将日期格式化为 YYYY-MM-DD
 * @param date Date类型的时间
 * @param field 时间显示粒度
 */
export const formatDate = (date, type = '') => {
    if (type == 'only') {
        const [year, month, day] = date.split('-');
        const formattedMonth = String(month).padStart(2, '0');
        const formattedDay = String(day).padStart(2, '0');
        return `${year}-${formattedMonth}-${formattedDay}`
    }
    const year = new Date(date).getFullYear();
    const month = String(new Date(date).getMonth() + 1).padStart(2, "0"); // 月份从0开始
    const day = String(new Date(date).getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
};
/**
 * 获取当月的date列表
 * @param date 属于目标月份的Date对象
 * @param startDay 一行的起点  比如以周一为起点 此时startDay = 1，以周日为起点，此时startDay = 0
 */
export const getDateListByMonth = (date, startDay = 0) => {
    const year = date.getFullYear();
    const month = date.getMonth();
    const firstDayOfMonth = new Date(year, month, 1); // 当前月的第一天
    const lastDayOfMonth = new Date(year, month + 1, 0); // 当前月的最后一天
    const days = [];

    // 补齐前一个月的日期
    let firstDayOfWeek = firstDayOfMonth.getDay(); // 当前月第一天是星期几（0-6，0 是周日）
    let offset = (firstDayOfWeek - startDay + 7) % 7; // 计算需要补齐的前一个月的日期数量
    for (let i = offset; i > 0; i--) {
        const prevMonthDate = new Date(year, month, -i + 1); // 前一个月的日期
        days.push({
            date: prevMonthDate.getDate(),
            currentMonth: false, // 标记为非当前月
            fullDateStr: formatDate(prevMonthDate),
        });
    }

    // 填充当前月的日期
    for (let day = 1; day <= lastDayOfMonth.getDate(); day++) {
        const currentDate = new Date(year, month, day);
        days.push({
            date: day,
            currentMonth: true, // 标记为当前月
            fullDateStr: formatDate(currentDate),
        });
    }

    // 补齐后一个月的日期
    let lastDayOfWeek = lastDayOfMonth.getDay(); // 当前月最后一天是星期几
    let nextMonthOffset = (6 - lastDayOfWeek + startDay) % 7; // 计算需要补齐的后一个月的日期数量
    for (let i = 1; i <= nextMonthOffset; i++) {
        const nextMonthDate = new Date(year, month + 1, i); // 后一个月的日期
        days.push({
            date: nextMonthDate.getDate(),
            currentMonth: false, // 标记为非当前月
            fullDateStr: formatDate(nextMonthDate),
        });
    }

    return days;
};
/**
* 计算current增加add天后是周几
* @param current 当前是第几天
* @param add 要加多少天
*/
export const calcWeekDay = (current, add) => {
    return (current + add) % 7;
};

/** 获取指定日期所在周的所有天
 * @param date 属于目标星期的Date对象
 * @param startDay 一行的起点  比如以周一为起点 此时startDay = 1，以周日为起点，此时startDay = 0
 */
export const getDateListByWeek = (date, startDay) => {
    date.setDate(date.getDate() - ((date.getDay() - startDay + 7) % 7));
    /** 一周的最后一天 */
    const weekEndDay = calcWeekDay(startDay, 6);
    let result = [];
    while (date.getDay() !== weekEndDay) {
        result.push({
            date: date.getDate(),
            currentMonth: true,
            fullDateStr: formatDate(date),
        });
        date.setDate(date.getDate() + 1);
    }
    result.push({
        date: date.getDate(),
        currentMonth: true,
        fullDateStr: formatDate(date),
    });
    return result;
};

export const getWeekDayList = (startDay) => {
    const weekDays = ["日", "月", "火", "水", "木", "金", "土"];
    // let result:any = [];
    // for (let i = startDay; i < 7; i++) {
    //   result.push(weekDays[i]);
    // }
    // for (let i = 0; i < startDay; i++) {
    //   result.push(weekDays[i]);
    // }
    // return result;
    return [...weekDays.slice(startDay), ...weekDays.slice(0, startDay)];
};

/**
 * 将日期字符串转换为 10 位的时间戳
 * @param dateStr 日期字符串，格式为 'YYYY-MM-DD'
 * @returns 10 位的时间戳
 */
export const convertDateToTimestamp = (dateStr) => {
    console.log(dateStr, 'dateStr')
    const date = new Date(dateStr);
    // 获取时间戳（毫秒）
    const timestampInMilliseconds = date.getTime();
    // 转换为 10 位时间戳（秒）
    const timestampInSeconds = Math.floor(timestampInMilliseconds / 1000);
    return timestampInSeconds;
};

/**
 * 将时间戳转换为 'MM月DD日 HH:mm' 格式的日期时间字符串
 * @param timestamp 时间戳（秒）
 * @returns 格式化后的日期时间字符串
 */
export const formatTimestampToDate = (timestamp, format = '') => {
    const date = new Date(timestamp * 1000);
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    switch (format) {
        case "day":
            return `${month}月${day}日`;
        default:
            return `${year}-${month}-${day}`;
    }
};


export const getCountdownMinutesSeconds = (orderTimestamp, handle = true) => {
    // 15 分钟的毫秒数 (15 * 60 * 1000)`
    let fifteenMinutesInMs = 0
    if (handle) {
        fifteenMinutesInMs = 15 * 60 * 1000;
    }
    // 计算倒计时结束的时间戳
    const endTime = orderTimestamp * 1000 + fifteenMinutesInMs;

    // 当前时间戳
    const now = Date.now();

    // 剩余时间（毫秒）
    let remainingTime = endTime - now;

    // 如果已经超时，返回 "00:00"
    if (remainingTime <= 0) {
        return "00:00";
    }

    // 计算分钟和秒数
    const minutes = Math.floor(remainingTime / (60 * 1000));
    const seconds = Math.floor((remainingTime % (60 * 1000)) / 1000);

    // 格式化为两位数，例如 5 -> "05"
    const formattedMinutes = minutes.toString().padStart(2, '0');
    const formattedSeconds = seconds.toString().padStart(2, '0');

    return `${formattedMinutes}:${formattedSeconds}`;
}


// 几天前发布
export function getTimeAgo(timestamp) {
    const now = Date.now();
    const diff = now - timestamp * 1000;
    const minutes = Math.floor(diff / (1000 * 60));

    if (minutes < 1) {
        return '刚刚发布';
    } else if (minutes < 60) {
        return `${minutes} 分钟前发布`;
    } else if (minutes < 1440) {
        const hours = Math.floor(minutes / 60);
        return `${hours} 小时前发布`;
    } else {
        const days = Math.floor(minutes / 1440);
        return `${days} 天前发布`;
    }
}

/**
 * 使用 RSA-OAEP (SHA-256) 加密数据（浏览器环境）
 * @param {string} pubKey - PEM 格式的 RSA 公钥 (PKCS#1 格式，以 "-----BEGIN RSA PUBLIC KEY-----" 开头)
 * @param {string} src - 要加密的原始字符串
 * @returns {Promise<string>} Base64 编码的加密结果
 * @throws {Error} 加密失败时抛出错误
 */
export async function rsaEncrypt(src) {
    try {
      // 1. 验证 PEM 格式
    //   if (!pubKey.includes('-----BEGIN RSA PUBLIC KEY-----')) {
    //     throw new Error('key is invalid format');
    //   }
  
      // 2. 提取 Base64 编码的 DER 数据
      const base64Der = Config.publicKey
        .replace(/-----BEGIN RSA PUBLIC KEY-----/, '')
        .replace(/-----END RSA PUBLIC KEY-----/, '')
        .replace(/\s+/g, '');
  
      // 3. 将 Base64 转为 Uint8Array (PKCS#1 DER)
      const pkcs1Der = base64ToUint8Array(base64Der);
  
      // 4. 转换为 SPKI 格式 (X.509) 的 DER
      const spkiDer = convertPkcs1ToSpki(pkcs1Der);
  
      // 5. 导入公钥
      const publicKey = await crypto.subtle.importKey(
        'spki',
        spkiDer,
        {
          name: 'RSA-OAEP',
          hash: 'SHA-256'
        },
        true,
        ['encrypt']
      );
  
      // 6. 执行加密
      const encryptedData = await crypto.subtle.encrypt(
        { name: 'RSA-OAEP' },
        publicKey,
        new TextEncoder().encode(src)
      );
  
      // 7. 转为 Base64 字符串
      return arrayBufferToBase64(encryptedData);
    } catch (err) {
      throw new Error(`RSA 加密失败：${err.message}`);
    }
  }
  
  // 工具函数：Base64 转 Uint8Array
  function base64ToUint8Array(base64) {
    const binaryString = atob(base64);
    const bytes = new Uint8Array(binaryString.length);
    for (let i = 0; i < binaryString.length; i++) {
      bytes[i] = binaryString.charCodeAt(i);
    }
    return bytes;
  }
  
  // 工具函数：ArrayBuffer 转 Base64
  function arrayBufferToBase64(buffer) {
    let binary = '';
    const bytes = new Uint8Array(buffer);
    for (let i = 0; i < bytes.byteLength; i++) {
      binary += String.fromCharCode(bytes[i]);
    }
    return btoa(binary);
  }
  
  // 核心转换函数：PKCS#1 DER → SPKI DER
  function convertPkcs1ToSpki(pkcs1Der) {
    // 1. 验证 PKCS#1 结构 (SEQUENCE 开头)
    if (pkcs1Der[0] !== 0x30) {
      throw new Error('Invalid PKCS#1 structure');
    }
  
    // 2. 构建 SPKI 的算法标识部分
    const algorithmId = new Uint8Array([
      0x30, 0x0d, 0x06, 0x09, 0x2a, 0x86, 0x48, 0x86, 
      0xf7, 0x0d, 0x01, 0x01, 0x01, 0x05, 0x00
    ]);
  
    // 3. 构建 BIT STRING 部分 (包含 PKCS#1 数据)
    const bitStringContent = new Uint8Array(1 + pkcs1Der.length);
    bitStringContent[0] = 0x00; // 未使用位 = 0
    bitStringContent.set(pkcs1Der, 1);
  
    // 4. 计算 BIT STRING 的长度编码
    const bitStringLength = bitStringContent.length;
    const bitStringHeader = [0x03, ...encodeDerLength(bitStringLength)];
  
    // 5. 组合 BIT STRING
    const bitString = new Uint8Array(
      bitStringHeader.length + bitStringContent.length
    );
    bitString.set(bitStringHeader);
    bitString.set(bitStringContent, bitStringHeader.length);
  
    // 6. 计算外层 SEQUENCE 长度
    const totalLength = algorithmId.length + bitString.length;
    const sequenceHeader = [0x30, ...encodeDerLength(totalLength)];
  
    // 7. 组合最终 SPKI DER
    const spkiDer = new Uint8Array(
      sequenceHeader.length + algorithmId.length + bitString.length
    );
    spkiDer.set(sequenceHeader);
    spkiDer.set(algorithmId, sequenceHeader.length);
    spkiDer.set(bitString, sequenceHeader.length + algorithmId.length);
  
    return spkiDer;
  }
  
  // DER 长度编码函数
  function encodeDerLength(length) {
    if (length < 0x80) {
      return [length];
    } else if (length < 0x100) {
      return [0x81, length];
    } else if (length < 0x10000) {
      return [0x82, length >> 8, length & 0xff];
    } else if (length < 0x1000000) {
      return [0x83, length >> 16, (length >> 8) & 0xff, length & 0xff];
    }
    throw new Error('Length too long for DER encoding');
  }
  